import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Divider,
  DrawerProps,
  Box,
} from '@mui/material'
import { useNavigate, useLocation } from 'react-router-dom'
import DashboardIcon from '@mui/icons-material/Dashboard'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import CompareArrowsIcon from '@mui/icons-material/CompareArrows'
import PeopleIcon from '@mui/icons-material/People'
import SettingsIcon from '@mui/icons-material/Settings'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import QueueIcon from '@mui/icons-material/Queue'
import HistoryIcon from '@mui/icons-material/History'
import SecurityIcon from '@mui/icons-material/Security'
import { useAuth } from '@/contexts/AuthContext'
import { UserRole } from '@/types/auth'

const drawerWidth = 240

interface SidebarProps {
  variant: DrawerProps['variant']
  open?: boolean
  onClose?: () => void
}

type MenuItem = {
  text: string
  path: string
  icon: React.ReactNode
  roles?: UserRole[]
}

const menuItems: MenuItem[] = [
  { text: 'Dashboard', icon: <DashboardIcon />, path: '/' },
  { text: 'Deposits', icon: <AccountBalanceIcon />, path: '/deposits' },
  { text: 'Withdrawals', icon: <AccountBalanceIcon />, path: '/withdrawals' },
  { text: 'SMS Requests', icon: <AccountBalanceIcon />, path: '/sms-requests' },
  { text: 'Transaction Queue', icon: <QueueIcon />, path: '/queue' },
  { text: 'Audit Trail', icon: <HistoryIcon />, path: '/audit-trail', roles: ['super_admin'] },
  { text: 'Fraud Detection', icon: <SecurityIcon />, path: '/fraud-detection', roles: ['super_admin'] },
  { text: 'Reconciliation', icon: <AccountBalanceIcon />, path: '/reconciliation', roles: ['super_admin'] },
  { text: 'Reports', icon: <TrendingUpIcon />, path: '/reports' },
  { text: 'Comparators', icon: <CompareArrowsIcon />, path: '/comparators' },
  { text: 'User Activity', icon: <PeopleIcon />, path: '/users' },
  { text: 'Inactive Users', icon: <PeopleIcon />, path: '/users/inactive' },
  { text: 'Configuration', icon: <SettingsIcon />, path: '/configuration', roles: ['super_admin'] },
  { text: 'System Info', icon: <SettingsIcon />, path: '/system', roles: ['super_admin'] },
  { text: 'User Management', icon: <AdminPanelSettingsIcon />, path: '/admin/users', roles: ['super_admin'] },
]

const Sidebar = ({ variant, open = true, onClose }: SidebarProps) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { hasRole } = useAuth()

  return (
    <Drawer
      variant={variant}
      open={open}
      onClose={onClose}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
        },
      }}
      ModalProps={{ keepMounted: true }}
    >
      <Toolbar />
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 2, px: 2 }}>
        <img src="/logo.png" alt="Logo" style={{ maxWidth: '180px', height: 'auto' }} />
      </Box>
      <Divider />
      <List>
        {menuItems
          .filter((item) => !item.roles || hasRole(item.roles))
          .map((item) => (
            <ListItem key={item.text} disablePadding>
              <ListItemButton selected={location.pathname === item.path} onClick={() => navigate(item.path)}>
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          ))}
      </List>
    </Drawer>
  )
}

export default Sidebar

